export default "__VITE_ASSET__ZHanE6Hb__"